import { useSession } from 'contexts/session-context'
import CONFIGS from 'build/Config'
import ComingSoonHtml from './html'
const ComingSoon = ({ children }: { children: JSX.Element[] }) => {
  const [session] = useSession()

  if (CONFIGS.comingSoon && session?.user?.id) {
    return <ComingSoonHtml />
  }
  return <>{children}</>
}

export default ComingSoon
